import { Component, Input } from '@angular/core';

@Component({
    selector: 'info-box',
    template: require('./info-box.component.html')
})
export class InfoBoxComponent {
    @Input() visible: boolean;
    @Input() text: string;
    @Input() counterText: string;
    @Input() iconCssClass: string;
    @Input() progressPercentage: number;
    @Input() iconCover: number = 100;

    //Possible Values: TextOnly, ProgressBar, CountDownTimer
    @Input() mode: string;
    @Input() forMicrophoneCheck: boolean;
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/info-box/info-box.component.ts